import React, {  useEffect, useState } from 'react'
import { connect } from 'react-redux'
import eventsActions from '../../../redux/actions/eventsActions'
import { baseURL } from '../../../config/config'
import imageCompression from 'browser-image-compression';


import './popup.css';

//Images
import camera from '../../../assets/images/camera.svg';
import LineRedImg from '../../../assets/images/Line-red.svg';

export const EditEventCategory = (props) => {
const reader = new FileReader();
const [category, setCategory] = useState({
    id:props?.selectedCategory?.id? props?.selectedCategory?.id : null,
    name:props?.selectedCategory?.name ? props?.selectedCategory?.name : '' ,
    title:props?.selectedCategory?.title ? props?.selectedCategory?.title: '', 
    age_from: props.selectedCategory.age_from? props.selectedCategory.age_from : '',
    age_to: props.selectedCategory.age_to? props.selectedCategory.age_to : '',
    subtitle: props?.selectedCategory?.subtitle ? props?.selectedCategory?.subtitle: '',
    meta_title:props?.selectedCategory?.meta_title ? props?.selectedCategory?.meta_title: '',
    description: props?.selectedCategory?.description ? props?.selectedCategory?.description: '',
    meta_description: props?.selectedCategory?.meta_description ? props?.selectedCategory?.meta_description: '',
    meta_keywords: props?.selectedCategory?.meta_keywords ? props?.selectedCategory?.meta_keywords: '',
    image: props?.selectedCategory?.image ? baseURL+'/image/event-categories/'+props.selectedCategory.image: '',
    display_order: props?.selectedCategory?.display_order ? props?.selectedCategory?.display_order: '',
    })

const [imageError, setImageError] = useState('');

const handleDataChange = (e,name) => {
    setCategory({
        ...category,
        [name]: e.target.value
    })
}

useEffect(()=>{
    if(category.image.length!==0){
        toDataURL(category.image, function(dataUrl) {
            setCategory({
                ...category,
                image: dataUrl
            })
        })
    }
},[])

const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) 
    checkImageDimensions(event.target.files[0]);
  }
const options = {
    maxSizeMB: 0.2,
    useWebWorker: true
};

const checkImageDimensions = (file) =>{
    var image = new Image();
    let reader = new FileReader();
    reader.onload = (e) => {
        image.src = e.target.result;
        image.onload = ()=>{
            setImageError('');
            compressImage(file)
        }
    };
    reader.readAsDataURL(file);
    
}
const compressImage =  (file) =>{
    imageCompression(file, options).then((compresssedFile)=>{
        createImage(compresssedFile)
    })
}
const createImage = (file) => {
    let reader = new FileReader();
    reader.onload = (e) => {
        setCategory({
            ...category,
            image: e.target.result,
          });
        
    };
    reader.readAsDataURL(file);
};


const toDataURL = (url, callback) => {
    var xhr = new XMLHttpRequest();
    xhr.onload = function() {
      reader.onloadend = function() {
        callback(reader.result);
      }
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }

const editEventCategory = (e) => {
    e.preventDefault();
    if(category.image.length===0){
        setImageError('Image is required')
        return
    }
    else{
        setImageError('')
        props.dispatch(eventsActions.editEventCategory({ data: category }))
    }
}

    return (
        <div>
            <div style={styles.headerContainer}>
				<img src={LineRedImg} alt='line Red' style={styles.lineRed} />
				<span style={styles.title}>Edit Events Category</span>
			</div>
                <form onSubmit={editEventCategory}>
                        <label className='labels'>
                            Title *
                        </label>
                        <input
                            type='text'
                            className='popup_Input_Carousel'
                            placeholder='Title'
                            name='tilte'
                            style={styles.inputTitle}
                            value={category.title}
                            required
                            onChange={(e) => {
                                handleDataChange(e,'title');
                            }}
                        ></input>
                        <label className='labels'>
                            Name *
                        </label>
                        <input
                            type='text'
                            placeholder='Name'
                            name='name'
                            className='popup_Input_Carousel'
                            style={styles.inputTitle}
                            value={category.name}
                            required
                            onChange={(e) => {
                                handleDataChange(e,'name');
                            }}
                        ></input>
                        <label className='labels'>
                            Minimum Age *
                        </label>
                        <input
                            type='number'
                            placeholder='Minimum Age'
                            name='age_from'
                            className='popup_Input_Carousel'
                            style={styles.inputTitle}
                            value={category.age_from}
                            required
                            onChange={(e) => {
                                handleDataChange(e,'age_from');
                            }}
                        ></input>
                        <label className='labels'>
                            Maximum Age *
                        </label>
                        <input
                            type='number'
                            placeholder='Maximum Age'
                            name='age_to'
                            className='popup_Input_Carousel'
                            style={styles.inputTitle}
                            value={category.age_to}
                            required
                            onChange={(e) => {
                                handleDataChange(e,'age_to');
                            }}
                            min={category.age_from}
                        ></input>
                        {(parseInt(category.age_to)<parseInt(category.age_from)) && <p className='error font-14'>Minimum age cannot exceed the maximum age</p>}
                        <label className='labels'>
                            Meta Title
                        </label>
                        <input
                            type='text'
                            className='popup_Input_Carousel'
                            placeholder='Meta Title'
                            name='meta_title'
                            style={styles.inputTitle}
                            value={category.meta_title}
                            onChange={(e) => {
                                handleDataChange(e,'meta_title');
                            }}
                        ></input>
                        <label className='labels'>
                            Subtitle
                        </label>
                        <input
                            type='text'
                            placeholder='Subtitle'
                            name='subtitle'
                            className='popup_Input_Carousel'
                            style={styles.inputTitle}
                            value={category.subtitle}
                            onChange={(e) => {
                                handleDataChange(e,'subtitle');
                            }}
                        ></input>
                        <label className='labels'>
                            Meta Keywords
                        </label>
                        <input
                            type='text'
                            placeholder='Meta Keywords'
                            name='meta_keywords'
                            className='popup_Input_Carousel'
                            style={styles.inputTitle}
                            value={category.meta_keywords}
                            onChange={(e) => {
                                handleDataChange(e,'meta_keywords');
                            }}
                        ></input>
                        <label className='labels'>
                            Description *
                        </label>
                        <textarea
                            type='text'
                            placeholder='Description'
                            name='description'
                            className='popup_Input_Carousel'
                            style={styles.textArea}
                            value={category.description}
                            required
                            onChange={(e) => {
                                handleDataChange(e,'description');
                            }}
                        ></textarea>
                        <label className='labels'>
                            Meta Description
                        </label>
                        <textarea
                            type='text'
                            placeholder='Meta Description'
                            name='meta_description'
                            className='popup_Input_Carousel'
                            style={styles.textArea}
                            value={category.meta_description}
                            onChange={(e) => {
                                handleDataChange(e,'meta_description');
                            }}
                        ></textarea>
                        <div style={{display: 'flex', flexDirection:'column'}}>
                        <label className='labels'>
                            Image *
                        </label>
                        <img
                         src={category.image}
                         className={category.image.length>0?styles.image_container:''}
                        ></img>
                        </div>
                        <div>
                            <button
                                type="button"
                                className='add_photo_btn'
                            >
                                <input
                                    onChange={(e) => {
                                        onImageChange(e);
                                    }}
                                    type='file'
                                    id='file'
                                    name='file'
                                    className='custom_file_input'
                                />
                                <label
                                    htmlFor='file'
                                    className='blue text-upper add_photo_label'
                                    style={{fontSize: '13pt' }}
                                >
                                    <img src={camera} alt='' />
                                    Update Image
                                </label>
                            </button>
                            {imageError && <p style={{fontSize:'14px', color:'red'}}>{imageError}</p>}
				        </div>
                        <div className='d-flex justify-content-between red'>
                        <button className='popup_button' style={styles.submit}
                        type="submit"
                            >
                                Edit Category
                        </button>
                        </div>
                </form>
        </div>
    )
}

const styles = {
	title: {
		color: '#262262',
		fontSize: '36px',
		fontStyle: 'bold',
		marginTop: '5px',
        marginBottom: '10px',
	},
	headerContainer: {
		display: 'flex',
		flexDirection: 'column',
	},
	lineRed: {
		width: '88px',
	},
	inputTitle: {
		width: '100%',
        marginTop:0,
		marginBottom: '10px',
		fontSize: '14pt',
	},
	textArea: {
		width: '100%',
		height: '200px',
		fontSize: '16pt',
        color: '#262262',
        marginTop:0,
		marginBottom: '10px',
	},
    image_container: {
        width: '70%',
        height:'300px',
        objectFit: 'fill',	
    },
    submit:{
        paddingTop: '5px'
    }
};

const mapStateToProps = (state) => ({
	selectedCategory: state.postReducer.selectedPost,
})

export default connect(mapStateToProps)(EditEventCategory)
